module.exports = __webpack_public_path__ + "img/10.d25ed852.gif";